import { createContext, useContext } from 'react';

export const siteThemeContext = createContext<boolean | null>(null);
export function useIsDarkTheme() {
	return useContext(siteThemeContext);
}
